import * as actions from './actions';
import * as getters from './getters';

import {
    FETCH_EMPLOYEES,
    FETCH_ARCHIVED_EMPLOYEES,
    FETCH_EMPLOYEES_BY_ROLE,
    FETCH_USER,

    ADD_EMPLOYEE,
    EDIT_EMPLOYEE_EMAIL,
    EDIT_EMPLOYEE_PASSWORD,
    EDIT_EMPLOYEE_FIRSTNAME,
    EDIT_EMPLOYEE_LASTNAME,
    EDIT_EMPLOYEE_COORDINATOR,
    EDIT_EMPLOYEE_TRACK_JIRA,
    EDIT_EMPLOYEE_VACATION_DAYS,
    CLEAR_EMPLOYEE_COORDINATOR,
    EDIT_EMPLOYEE_EDIT_PHONE,
    EDIT_EMPLOYEE_ADD_PHONE,
    EDIT_EMPLOYEE_ADD_FACILITY,
    EDIT_EMPLOYEE_ADD_BENEFIT,
    EDIT_EMPLOYEE_REMOVE_PHONE,
    EDIT_EMPLOYEE_EDIT_POSITION,
    EDIT_EMPLOYEE_ADD_POSITION,
    EDIT_EMPLOYEE_REMOVE_POSITION,
    EDIT_EMPLOYEE_REMOVE_FACILITY,
    EDIT_EMPLOYEE_REMOVE_BENEFIT,
    EDIT_EMPLOYEE_FACILITY_DEVICE_CHANGE,
    EDIT_EMPLOYEE_FACILITY_TYPE_CHANGE,
    EDIT_EMPLOYEE_FACILITY_NUMBER_CHANGE,
    EDIT_EMPLOYEE_BENEFIT_CHANGE,
    EDIT_EMPLOYEE_SKYPE,
    EDIT_EMPLOYEE_TELEGRAM,
    EDIT_EMPLOYEE_CONTACT_EMAIL,
    EDIT_EMPLOYEE_ROCKETCHAT,
    EDIT_EMPLOYEE_ENGLISH,
    EDIT_EMPLOYEE_PHOTOURL,
    SET_UPLOADING_PHOTO,
    VIEW_EMPLOYEE,
    DELETE_EMPLOYEE,
    ARCHIVE_EMPLOYEE,
    DUPLICATE_EMPLOYEE,
    ADD_NEW_EMPLOYEE,
    EDIT_EMPLOYEE,
    SEARCH_EMPLOYEE,

    FETCH_ROLES,
    DELETE_ROLE,
    EDIT_ROLE,
    TOGGLE_ROLE,
    TOGGLE_ADMIN_ROLE,
    MAP_ROLES,
    ADD_ROLE,
    SAVE_ROLE,
    CANCEL_EDIT_ROLE,

    FETCH_DEPARTMENTS,
    SAVE_DEPARTMENT,
    DELETE_DEPARTMENT,
    EDIT_DEPARTMENT,
    ADD_DEPARTMENT,
    CANCEL_EDIT_DEPARTMENT,
    TOGGLE_DEPARTMENT,
    MAP_DEPARTMENTS,

    UPDATE_SALARY,
    EDIT_SALARY,
    UPDATE_SALARY_AMOUNT,
    UPDATE_SALARY_CHANGE_REASON,
    UPDATE_SALARY_CURRENCY,
    UPDATE_SALARY_DATE,
    DELETE_SALARY,
    ADD_SALARY,

    FETCH_CURRENCIES,
    ADD_CURRENCY,
    DELETE_CURRENCY,
    SAVE_CURRENCY,
    EDIT_CURRENCY,
    CANCEL_EDIT_CURRENCY,

    FETCH_FACILITY_TYPES,
    ADD_FACILITY_TYPE,
    DELETE_FACILITY_TYPE,
    SAVE_FACILITY_TYPE,
    EDIT_FACILITY_TYPE,
    CANCEL_EDIT_FACILITY_TYPE,

    FETCH_FACILITY_DEVICES,
    ADD_FACILITY_DEVICE,
    DELETE_FACILITY_DEVICE,
    SAVE_FACILITY_DEVICE,
    EDIT_FACILITY_DEVICE,
    CANCEL_EDIT_FACILITY_DEVICE,

    FETCH_BENEFITS,
    ADD_BENEFIT,
    DELETE_BENEFIT,
    SAVE_BENEFIT,
    EDIT_BENEFIT,
    CANCEL_EDIT_BENEFIT,

    CHECK_GOOGLE_ACCOUNT,
    EDIT_GOOGLE_ACCOUNT_CREATION
} from './mutation-types';

const initialState = {
    all: [],
    archived: [],
    coordinators: [],
    directors: [],
    employee: {
        positions: [{position: ''}]
    },
    originalEmployee: {},
    roles: [],
    departments: [],
    newDepartment: '',
    newSalary: {
        amount: null,
        changeReason: '',
        currency: null,
        currencyId: null,
        updatedDate: null,
        userId: ''
    },
    searchEmployees: '',
    uploadingPhoto: null,
    currencies: [],
    facilityTypes: [],
    facilityDevices: [],
    benefits: [],
    googleAccountInfo: {},
    createGoogleAccount: true
};

const mutations = {
    [FETCH_EMPLOYEES](state, employees) {
        state.all = [...employees];
    },

    [FETCH_ARCHIVED_EMPLOYEES](state, archivedEmployees) {
        state.archived = [...archivedEmployees];
    },

    [FETCH_EMPLOYEES_BY_ROLE](state, payload) {
        switch (payload.role) {
            case 'coordinator':
                state.coordinators = [...payload.employees];
                break;
            case 'director':
                state.directors = [...payload.employees];
                break;
        }
    },

    [CHECK_GOOGLE_ACCOUNT](state, payload) {
        state.employee = {
            ...state.employee,
            googleAccountInfo: {
                ...payload
            }
        };
    },

    [EDIT_GOOGLE_ACCOUNT_CREATION](state, createGoogleAccount) {
        state.employee = {
            ...state.employee,
            createGoogleAccount
        };
    },

    [ADD_EMPLOYEE](state) {
        state.employee = {
            coordinator: null,
            departments: [],
            email: '',
            englishLevel: '',
            firstname: '',
            isCoordinator: false,
            lastname: '',
            password: '',
            phoneNumbers: [{ prefix: '+375', number: '' }],
            positions: [{position: ''}],
            rocketChat: '',
            roles: [],
            salaryHistory: [],
            facilities: [{ device: null, type: null, modelNumber: '' }],
            benefits: [{ id: -1, name: '' }],
            skype: '',
            telegram: '',
            contactEmail: '',
            trackJira: false,
            photoUrl: '',
            createGoogleAccount: true,
            googleAccountInfo: {}
        };
        state.uploadingPhoto = null;
    },

    [EDIT_EMPLOYEE_EMAIL](state, email) {
        state.employee = {
            ...state.employee,
            email
        };
    },

    [EDIT_EMPLOYEE_PASSWORD](state, password) {
        state.employee = {
            ...state.employee,
            password
        };
    },

    [EDIT_EMPLOYEE_FIRSTNAME](state, firstname) {
        state.employee = {
            ...state.employee,
            firstname
        };
    },

    [EDIT_EMPLOYEE_LASTNAME](state, lastname) {
        state.employee = {
            ...state.employee,
            lastname
        };
    },

    [EDIT_EMPLOYEE_COORDINATOR](state, coordinator) {
        state.employee = {
            ...state.employee,
            coordinator
        };
    },

    [EDIT_EMPLOYEE_TRACK_JIRA](state, trackJira) {
        state.employee = {
            ...state.employee,
            trackJira
        };
    },

    [EDIT_EMPLOYEE_VACATION_DAYS](state, vacationDays) {
        state.employee = {
            ...state.employee,
            vacationDays
        };
    },

    [CLEAR_EMPLOYEE_COORDINATOR](state) {
        state.employee.coordinator = null;
    },

    [EDIT_EMPLOYEE_EDIT_PHONE](state, phoneNumbers) {
        state.employee.phoneNumbers = [...phoneNumbers];
    },
    [EDIT_EMPLOYEE_ADD_PHONE](state) {
        state.employee.phoneNumbers = [
            {
                prefix: '+375',
                number: ''
            },
            ...state.employee.phoneNumbers
        ];
    },
    [EDIT_EMPLOYEE_EDIT_POSITION](state, positions) {
        state.employee.positions = [...positions];
    },
    [EDIT_EMPLOYEE_ADD_POSITION](state) {
        state.employee.positions = [
            {
                name: '',
                schedule: '',
                contractStart: null,
                contractLapse: null,
                probationDate: null,
                hiringPicker: false,
                contractPicker: false,
                probationPicker: false
            },
            ...state.employee.positions
        ];
    },
    [EDIT_EMPLOYEE_ADD_FACILITY](state) {
        state.employee.facilities = [
            ...state.employee.facilities,
            {
                device: null,
                type: null,
                modelNumber: '',
                userId: state.employee.userId
            }
        ];
    },

    [EDIT_EMPLOYEE_FACILITY_DEVICE_CHANGE](state, facilityDevice) {
        state.employee.facilities[facilityDevice.index].device = {
            name: facilityDevice.name,
            id: facilityDevice.id
        };
        state.employee.facilities[facilityDevice.index].deviceId = facilityDevice.id;
    },

    [EDIT_EMPLOYEE_FACILITY_TYPE_CHANGE](state, facilityType) {
        state.employee.facilities[facilityType.index].type = {
            name: facilityType.name,
            id: facilityType.id
        };
        state.employee.facilities[facilityType.index].typeId = facilityType.id;
    },

    [EDIT_EMPLOYEE_FACILITY_NUMBER_CHANGE](state, facilityNumber) {
        state.employee.facilities[facilityNumber.index].modelNumber = facilityNumber.value;
    },

    [EDIT_EMPLOYEE_BENEFIT_CHANGE](state, benefit) {
        state.employee.benefits[benefit.index].benefit = {
            name: benefit.name,
            id: benefit.id
        };
        state.employee.benefits[benefit.index].name = benefit.name;
        state.employee.benefits[benefit.index].id = benefit.id;
    },

    [EDIT_EMPLOYEE_ADD_BENEFIT](state) {
        state.employee.benefits = [
            ...state.employee.benefits,
            {
                id: -1,
                name: ''
            }
        ];
    },

    [EDIT_EMPLOYEE_REMOVE_PHONE](state, index) {
        state.employee.phoneNumbers.splice(index, 1);
    },

    [EDIT_EMPLOYEE_REMOVE_POSITION](state, index) {
        state.employee.positions.splice(index, 1);
    },

    [EDIT_EMPLOYEE_REMOVE_FACILITY](state, index) {
        if (state.employee.facilities.length === 1) {
            state.employee.facilities[0].type = null;
            state.employee.facilities[0].device = null;
            state.employee.facilities[0].modelNumber = '';
            state.employee.facilities[0].userId = state.employee.userId;
        } else {
            state.employee.facilities.splice(index, 1);
        }
    },

    [EDIT_EMPLOYEE_REMOVE_BENEFIT](state, index) {
        if (state.employee.benefits.length === 1) {
            state.employee.benefits[0].id = -1;
            state.employee.benefits[0].name = '';
            state.employee.benefits[0].benefit = null;
        } else {
            state.employee.benefits.splice(index, 1);
        }
    },

    [EDIT_EMPLOYEE_SKYPE](state, skype) {
        state.employee = {
            ...state.employee,
            skype
        };
    },

    [EDIT_EMPLOYEE_TELEGRAM](state, telegram) {
        state.employee = {
            ...state.employee,
            telegram
        };
    },

    [EDIT_EMPLOYEE_ROCKETCHAT](state, rocketChat) {
        state.employee = {
            ...state.employee,
            rocketChat
        };
    },

    [EDIT_EMPLOYEE_CONTACT_EMAIL](state, contactEmail) {
        state.employee = {
            ...state.employee,
            contactEmail
        };
    },

    [EDIT_EMPLOYEE_ENGLISH](state, englishLevel) {
        state.employee = {
            ...state.employee,
            englishLevel
        };
    },

    [EDIT_EMPLOYEE_PHOTOURL](state, photoUrl) {
        state.employee = {
            ...state.employee,
            photoUrl
        };
    },

    [SET_UPLOADING_PHOTO](state, photo) {
        state.uploadingPhoto = photo;
    },

    [VIEW_EMPLOYEE](state, employee) {
        if (!employee.phoneNumbers || !employee.phoneNumbers.length) {
            employee.phoneNumbers = [{ prefix: '+375', number: '' }];
        } else {
            employee.phoneNumbers.forEach(phoneNumber => {
                phoneNumber.prefix = phoneNumber.number.startsWith('+375')
                    ? '+375'
                    : '+7';
            });
        }

        if (!employee.facilities || !employee.facilities.length) {
            employee.facilities = [{
                device: null,
                type: null,
                modelNumber: '',
                userId: employee.userId
            }];
        }

        if (!employee.benefits || !employee.benefits.length) {
            employee.benefits = [{
                id: -1,
                name: ''
            }];
        } else {
            employee.benefits = employee.benefits.map(benefit => ({ ...benefit, benefit }));
        }

        employee.googleAccountInfo = {};
        employee.createGoogleAccount = true;
        state.employee = {...employee};
        state.employee.positions = state.employee.positions && state.employee.positions.length > 0
            ? state.employee.positions
            : [{position: ''}];
        state.originalEmployee = employee;
        state.uploadingPhoto = null;
    },

    [ADD_NEW_EMPLOYEE](state, newEmployee) {
        state.all = [...state.all, newEmployee];
    },

    [EDIT_EMPLOYEE](state, employee) {
        state.employee = employee;
        state.originalEmployee = employee;
    },

    [DELETE_EMPLOYEE](state, userId) {
        state.all = state.all.filter(user => user.userId !== userId);
    },

    [ARCHIVE_EMPLOYEE](state, userId) {
        state.all = state.all.filter(user => user.userId !== userId);
    },

    [DUPLICATE_EMPLOYEE](state, userId) {
        if (state.all.findIndex(item => item.userId === userId) === -1) {
            const duplicatedEmployee = state.archived.find(
                item => item.userId === userId
            );
            duplicatedEmployee.duplicated = true;
            state.all = [...state.all, duplicatedEmployee];
        }
    },

    [SEARCH_EMPLOYEE](state, searchText) {
        state.searchEmployees = searchText;
    },

    // roles

    [FETCH_ROLES](state, roles) {
        state.roles = [
            ...roles.map(x => {
                return {
                    name: x.name,
                    id: x.id,
                    editting: false,
                    checked: false,
                    editable: x.editable
                };
            })
        ];

        let rolesList = state.employee.roles;
        if (rolesList && rolesList.length) {
            state.roles = state.roles.map(role => ({
                ...role,
                checked: rolesList.some(item => item.id === role.id)
            }));
        }
    },

    [DELETE_ROLE](state, id) {
        state.roles = state.roles.filter(role => role.id !== id);
    },

    [EDIT_ROLE](state, itemId) {
        state.roles = state.roles.filter(role => role.id !== -1).map(role => ({
            ...role,
            editting: role.id === itemId
        }));
    },

    [ADD_ROLE](state, role) {
        const filteredRoles = state.roles
            .filter(role => role.id !== -1)
            .map(role => ({
                ...role,
                editting: false
            }));

        state.roles = [...filteredRoles, role];
    },

    [CANCEL_EDIT_ROLE](state) {
        const index = state.roles.findIndex(role => role.editting);

        if (index !== -1) {
            if (state.roles[index].id > 0) {
                state.roles[index].editting = false;
            } else {
                state.roles.splice(index, 1);
            }
        }
    },

    [SAVE_ROLE](state, role) {
        const index = state.roles.findIndex(role => role.editting);

        if (index !== -1) {
            state.roles[index].id = role.id;
            state.roles[index].editting = false;
        }
    },

    [TOGGLE_ROLE](state, item) {
        state.roles = state.roles
            .map(role => ({
                ...role,
                checked: role.name.trim().toLowerCase() === 'administrator'
                    ? role.checked
                    : role.id === item.id
                        ? item.checked
                        : false
            }));
    },

    [TOGGLE_ADMIN_ROLE](state, item) {
        const adminRole = state.roles.find(role => role.id === item.id);
        adminRole.checked = item.checked;
    },

    [MAP_ROLES](state, roles) {
        state.employee.roles = [
            ...roles.map(x => {
                return {
                    id: x.id,
                    name: x.name
                };
            })
        ];
    },

    // departments

    [FETCH_DEPARTMENTS](state, departments) {
        const employeeDepartments = state.employee.departments;

        state.departments = [
            ...departments.map(department => ({
                name: department.name,
                id: department.id,
                editting: false,
                checked:
                    employeeDepartments &&
                    employeeDepartments.some(elem => elem.id === department.id),
                editable: true
            }))
        ];
    },

    [SAVE_DEPARTMENT](state, department) {
        const index = state.departments.findIndex(
            department => department.editting
        );

        if (index !== -1) {
            state.departments[index].id = department.id;
            state.departments[index].editting = false;
        }
    },

    [DELETE_DEPARTMENT](state, id) {
        state.departments = state.departments.filter(
            department => department.id !== id
        );
    },

    [EDIT_DEPARTMENT](state, id) {
        state.departments = state.departments
            .filter(department => department.id !== -1)
            .map(department => ({
                ...department,
                editting: department.id === id
            }));
    },

    [ADD_DEPARTMENT](state, department) {
        state.departments = [
            ...state.departments
                .filter(department => department.id !== -1)
                .map(department => ({
                    ...department,
                    editting: false
                })),
            department
        ];
    },

    [CANCEL_EDIT_DEPARTMENT](state) {
        const index = state.departments.findIndex(
            department => department.editting
        );

        if (index !== -1) {
            if (state.departments[index].id > 0) {
                state.departments[index].editting = false;
            } else {
                state.departments.splice(index, 1);
            }
        }
    },

    [TOGGLE_DEPARTMENT](state, item) {
        const index = state.departments.findIndex(
            department => department.id === item.id
        );
        state.departments[index].checked = item.checked;
    },

    [MAP_DEPARTMENTS](state, departments) {
        state.employee.departments = [
            ...departments.map(department => ({
                id: department.id,
                name: department.name
            }))
        ];
    },

    // salary

    [UPDATE_SALARY](state, newSalary) {
        state.newSalary = {
            ...newSalary
        };
    },

    [EDIT_SALARY](state, payload) {
        state.employee.salaryHistory.splice(
            payload.editIndex,
            1,
            payload.newSalary
        );
    },

    [UPDATE_SALARY_AMOUNT](state, amount) {
        state.newSalary.amount = amount;
    },

    [UPDATE_SALARY_CHANGE_REASON](state, reason) {
        state.newSalary.changeReason = reason;
    },

    [UPDATE_SALARY_CURRENCY](state, currency) {
        state.newSalary.currency = currency;
        state.newSalary.currencyId = currency.id;
    },

    [UPDATE_SALARY_DATE](state, date) {
        const dateObj = new Date(date);
        state.newSalary.updatedDate = dateObj.toISOString();
    },

    [DELETE_SALARY](state, salaryIndex) {
        state.employee.salaryHistory.splice(salaryIndex, 1);
    },

    [ADD_SALARY](state, newSalary) {
        state.employee.salaryHistory = [
            ...state.employee.salaryHistory,
            newSalary
        ];
    },

    [FETCH_USER](state, user) {
        state.employee = user;
    },

    [FETCH_CURRENCIES](state, currencies) {
        state.currencies = [
            ...currencies.map(currency => {
                return {
                    name: currency.name,
                    id: currency.id,
                    editting: false,
                    checked: false,
                    editable: true
                };
            })
        ];
    },

    [ADD_CURRENCY](state, newCurrency) {
        state.currencies = [
            ...state.currencies
                .filter(currency => currency.id !== -1)
                .map(currency => ({
                    ...currency,
                    editting: false
                })),
            newCurrency
        ];
    },

    [DELETE_CURRENCY](state, currencyId) {
        state.currencies = state.currencies.filter(item => item.id !== currencyId);
    },

    [SAVE_CURRENCY](state, currency) {
        const currencyId = state.currencies.findIndex(currency => currency.editting);

        if (currencyId !== -1) {
            state.currencies[currencyId].id = currency.id;
            state.currencies[currencyId].editting = false;
        }
    },

    [EDIT_CURRENCY](state, currencyId) {
        state.currencies = state.currencies
            .filter(currency => currency.id !== -1)
            .map(currency => ({
                ...currency,
                editting: currency.id === currencyId
            }));
    },

    [CANCEL_EDIT_CURRENCY](state) {
        const currencyIndex = state.currencies.findIndex(currency => currency.editting);

        if (currencyIndex !== -1) {
            if (state.currencies[currencyIndex].id > 0) {
                state.currencies[currencyIndex].editting = false;
            } else {
                state.currencies.splice(currencyIndex, 1);
            }
        }
    },

    [FETCH_FACILITY_TYPES](state, facilityTypes) {
        state.facilityTypes = [
            ...facilityTypes.map(facilityType => {
                return {
                    name: facilityType.name,
                    id: facilityType.id,
                    editting: false,
                    checked: false,
                    editable: true
                };
            })
        ];
    },

    [ADD_FACILITY_TYPE](state, newFacilityType) {
        state.facilityTypes = [
            ...state.facilityTypes
                .filter(facilityType => facilityType.id !== -1)
                .map(facilityType => ({
                    ...facilityType,
                    editting: false
                })),
            newFacilityType
        ];
    },

    [DELETE_FACILITY_TYPE](state, facilityTypeId) {
        state.facilityTypes = state.facilityTypes.filter(item => item.id !== facilityTypeId);
    },

    [SAVE_FACILITY_TYPE](state, facilityType) {
        const facilityTypeId = state.facilityTypes.findIndex(facilityType => facilityType.editting);

        if (facilityTypeId !== -1) {
            state.facilityTypes[facilityTypeId].id = facilityType.id;
            state.facilityTypes[facilityTypeId].editting = false;
        }
    },

    [EDIT_FACILITY_TYPE](state, facilityTypeId) {
        state.facilityTypes = state.facilityTypes
            .filter(facilityType => facilityType.id !== -1)
            .map(facilityType => ({
                ...facilityType,
                editting: facilityType.id === facilityTypeId
            }));
    },

    [CANCEL_EDIT_FACILITY_TYPE](state) {
        const facilityTypeIndex = state.facilityTypes.findIndex(facilityType => facilityType.editting);

        if (facilityTypeIndex !== -1) {
            if (state.facilityTypes[facilityTypeIndex].id > 0) {
                state.facilityTypes[facilityTypeIndex].editting = false;
            } else {
                state.facilityTypes.splice(facilityTypeIndex, 1);
            }
        }
    },

    [FETCH_FACILITY_DEVICES](state, facilityDevices) {
        state.facilityDevices = [
            ...facilityDevices.map(facilityDevice => {
                return {
                    name: facilityDevice.name,
                    id: facilityDevice.id,
                    editting: false,
                    checked: false,
                    editable: true
                };
            })
        ];
    },

    [ADD_FACILITY_DEVICE](state, newFacilityDevice) {
        state.facilityDevices = [
            ...state.facilityDevices
                .filter(facilityDevice => facilityDevice.id !== -1)
                .map(facilityDevice => ({
                    ...facilityDevice,
                    editting: false
                })),
            newFacilityDevice
        ];
    },

    [DELETE_FACILITY_DEVICE](state, facilityDeviceId) {
        state.facilityDevices = state.facilityDevices.filter(item => item.id !== facilityDeviceId);
    },

    [SAVE_FACILITY_DEVICE](state, facilityDevice) {
        const facilityDeviceId = state.facilityDevices.findIndex(facilityDevice => facilityDevice.editting);

        if (facilityDeviceId !== -1) {
            state.facilityDevices[facilityDeviceId].id = facilityDevice.id;
            state.facilityDevices[facilityDeviceId].editting = false;
        }
    },

    [EDIT_FACILITY_DEVICE](state, facilityDeviceId) {
        state.facilityDevices = state.facilityDevices
            .filter(facilityDevice => facilityDevice.id !== -1)
            .map(facilityDevice => ({
                ...facilityDevice,
                editting: facilityDevice.id === facilityDeviceId
            }));
    },

    [CANCEL_EDIT_FACILITY_DEVICE](state) {
        const facilityDeviceIndex = state.facilityDevices.findIndex(facilityDevice => facilityDevice.editting);

        if (facilityDeviceIndex !== -1) {
            if (state.facilityDevices[facilityDeviceIndex].id > 0) {
                state.facilityDevices[facilityDeviceIndex].editting = false;
            } else {
                state.facilityDevices.splice(facilityDeviceIndex, 1);
            }
        }
    },

    [FETCH_BENEFITS](state, benefits) {
        state.benefits = [
            ...benefits.map(benefit => {
                return {
                    name: benefit.name,
                    id: benefit.id,
                    editting: false,
                    checked: false,
                    editable: true
                };
            })
        ];
    },

    [ADD_BENEFIT](state, newBenefit) {
        state.benefits = [
            ...state.benefits
                .filter(benefit => benefit.id !== -1)
                .map(benefit => ({
                    ...benefit,
                    editting: false
                })),
            newBenefit
        ];
    },

    [DELETE_BENEFIT](state, benefitId) {
        state.benefits = state.benefits.filter(item => item.id !== benefitId);
    },

    [SAVE_BENEFIT](state, benefit) {
        const benefitId = state.benefits.findIndex(benefit => benefit.editting);

        if (benefitId !== -1) {
            state.benefits[benefitId].id = benefit.id;
            state.benefits[benefitId].editting = false;
        }
    },

    [EDIT_BENEFIT](state, benefitId) {
        state.benefits = state.benefits
            .filter(benefit => benefit.id !== -1)
            .map(benefit => ({
                ...benefit,
                editting: benefit.id === benefitId
            }));
    },

    [CANCEL_EDIT_BENEFIT](state) {
        const benefitIndex = state.benefits.findIndex(benefit => benefit.editting);

        if (benefitIndex !== -1) {
            if (state.benefits[benefitIndex].id > 0) {
                state.benefits[benefitIndex].editting = false;
            } else {
                state.benefits.splice(benefitIndex, 1);
            }
        }
    }
};

export default {
    state: {
        ...initialState
    },
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/employees/index.js